module.exports = __webpack_public_path__ + "img/financial_open.ae597a44.png";